import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import { reducer as formReducer } from 'redux-form';
import shopReducers from './shopReducers';
import contactReducers from './contactReducers';
import chartOfAccountReducers from './chartOfAccountReducers';
import featureClassReducers from './featureClassReducers';
import productFeatures from './productMainEdit/productFeatureReducers';
import productLocations from './productMainEdit/productLocationReducers';
import sessions from './sessionReducers';

const rootReducer = combineReducers({
   contacts: contactReducers,
   chartOfAccounts: chartOfAccountReducers,
   featureClasses: featureClassReducers,
   shops: shopReducers,
   productFeatures,
   productLocations,
   sessions,
   routing: routerReducer,
   form: formReducer
});

export default rootReducer;



/** WEBPACK FOOTER **
 ** ./src/reducers/index.js
 **/